<template>
  <div v-if="isMenu" class="sidebar">
    <el-scrollbar wrap-class="scrollbar-wrapper" style="margin-right: 0; height: inherit">
      <el-menu :collapse="collapse" :unique-opened="true" :collapse-transition="true" router
        class="el-menu-vertical-demo" :default-active="this.$route.meta.index" mode="vertical"
        :default-openeds="open_list" @select="handleSelect" background-color="#354052">
        <!-- <div class="logobox">
          <img class="logoimg" :src="logoImage" />
        </div> -->
        <!-- 10008的logo -->
        <div class="logobox">
          <img class="logoimg" :src="logoImage" />
          <!-- // 给金威单独定制首页 -->
          <!-- <span>称重查询端</span> -->
        </div>

        <template v-for="item in allmenu">
          <template v-if="item.children">
            <el-submenu :index="'/' + item.urlst" :key="item.rescid">
              <template slot="title">
                <i :class="item.icon"></i>
                <span slot="title">{{ item.namest }} </span>
              </template>

              <template v-for="subItem in item.children" :index="subItem.rescid">
                <el-menu-item-group :key="subItem.rescid" v-if="!subItem.children" class="name">

                  <el-menu-item :index="'/' + subItem.urlst">
                    <i :class="subItem.icon"></i>
                    {{ subItem.namest }}
                  </el-menu-item>
                </el-menu-item-group>

                <el-submenu :index="'/' + subItem.urlst" v-else>
                  <i :class="subItem.icon"></i>
                  <span slot="title">{{ subItem.namest }}</span>
                  <el-menu-item v-for="subItems in subItem.children" :key="subItems.rescid"
                    :index="'/' + subItems.urlst">{{ subItems.namest }}</el-menu-item>
                </el-submenu>
              </template>
            </el-submenu>
          </template>
          <template v-else>
            <el-menu-item :index="'/' + item.urlst" :key="item.rescid">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.namest }}</span>
            </el-menu-item>
          </template>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>
<script>
import NavMenu from "./NavMenu.vue";
import { mapGetters } from "vuex";
export default {
  name: "leftnav",
  components: {
    NavMenu: NavMenu,
  },
  data() {
    return {
      allmenu: [],
      isMenu: true,
      logoImage: "",
      open_list: [],
    };
  },
  mounted() {
    let that = this;
    that.allmenu =
      [
        {
          rescid: "1", //id
          urlst: "weightCloud/weightIndex", //url
          icon: "el-icon-s-order", //图标
          namest: "数据简报", //名称
        },
        {
          rescid: "2", //id
          urlst: "users/userList", //url
          children: [
            {
              rescid: "2-1", //id
              urlst: "weightSearch/dataSearch", //url
              icon: "el-icon-coin", //图标
              namest: "数据查询", //名称
            },
            {
              rescid: "2-2", //id
              urlst: "weightSearch/dataSearchNew", //url
              icon: "el-icon-coin", //图标
              namest: "数据查询(新)", //名称
            },
            {
              rescid: "2-11", //id
              urlst: "weightSearch/dataSearchGrain", //url
              icon: "el-icon-coin", //图标
              namest: "数据查询(收粮)", //名称
            },
            {
              rescid: "2-3", //id
              urlst: "weightSearch/dataSummary", //url
              icon: "el-icon-coin", //图标
              namest: "数据汇总(新)", //名称
            },
            // {
            //   rescid: "2-4", //id
            //   urlst: "weightSearch/carSummary", //url
            //   icon: "el-icon-coin", //图标
            //   namest: "车次汇总", //名称
            // },
            // {
            //   rescid: "2-5", //id
            //   urlst: "weightSearch/goodsSummary", //url
            //   icon: "el-icon-coin", //图标
            //   namest: "货名汇总", //名称
            // },
            // {
            //   rescid: "2-6", //id
            //   urlst: "weightSearch/deliverSummary", //url
            //   icon: "el-icon-coin", //图标
            //   namest: "发货单位汇总", //名称
            // },
            // {
            //   rescid: "2-7", //id
            //   urlst: "weightSearch/receiveSummary", //url
            //   icon: "el-icon-coin", //图标
            //   namest: "收货单位汇总", //名称
            // }, {
            //   rescid: "2-8", //id
            //   urlst: "weightSearch/rechargeSummary", //url
            //   icon: "el-icon-coin", //图标
            //   namest: "充值汇总", //名称
            // },
            // {
            //   rescid: "2-11", //id
            //   urlst: "weightSearch/priceSummary", //url
            //   icon: "el-icon-coin", //图标
            //   namest: "充值历史", //名称
            // },
          ], //子菜单
          icon: "el-icon-s-order", //图标
          namest: "统计查询", //名称
        },

        {
          rescid: "4", //id
          urlst: "manage/manageIndex", //url
          children: [

            {
              rescid: "4-0", //id
              urlst: "manage/unitManage", //url
              icon: "el-icon-bank-card", //图标
              namest: "单位管理", //名称
            },

            {
              rescid: "4-1", //id
              urlst: "manage/goodsManage", //url
              icon: "el-icon-bank-card", //图标
              namest: "品名管理", //名称
            },
            {
              rescid: "4-2", //id
              urlst: "manage/spec", //url
              icon: "el-icon-bank-card", //图标
              namest: "规格管理", //名称
            },
            {
              rescid: "4-3", //id
              urlst: "manage/carManage", //url
              icon: "el-icon-bank-card", //图标
              namest: "车辆信息", //名称
            },
            {
              rescid: "4-4", //id
              urlst: "manage/accountManage", //url
              icon: "el-icon-bank-card", //图标
              namest: "远程充值", //名称
            },
            {
              rescid: "4-5", //id
              urlst: "manage/userManage", //url
              icon: "el-icon-bank-card", //图标
              namest: "用户信息", //名称
            },

            {
              rescid: "4-6", //id
              urlst: "manage/systemSetting", //url
              icon: "el-icon-bank-card", //图标
              namest: "系统设置", //名称
            },
          ], //子菜单
          icon: "el-icon-s-order", //图标
          namest: "系统管理", //名称
        },
      ];

    // 定制区域********************************************************************************
    // 获取当前登录UserName
    let loginName = that.$store.state.loginName;

    // 添加的菜单对象
    let obj = {
      rescid: "2-10", //id
      urlst: "manage/trainNumber", //url
      icon: "el-icon-bank-card", //图标
      namest: "车次统计", //名称
    }
    // 当用户名==10000时,添加车次统计  || loginName == '10000'
    if (loginName == '30229' || loginName == '30228' || loginName == '30216') {
      that.allmenu[1].children.splice(6, 0, obj)
    }



    // 定制区域********************************************************************************

    // 多单位查询 路由
    let obj2 = {
      rescid: "2-9", //id
      urlst: "weightSearch/searchUnit", //url
      icon: "el-icon-coin", //图标
      namest: "多站点查询", //名称
    }

    // 预约审核

    let appointment = {
      rescid: "3", //id
      urlst: "other/index", //url
      children: [
        {
          rescid: "3-1", //id
          urlst: "appointmentReview/pendingApproval", //url
          icon: "el-icon-s-order", //图标
          namest: "待审核", //名称
        },

        {
          rescid: "3-2", //id
          urlst: "appointmentReview/audited", //url
          icon: "el-icon-s-order", //图标
          namest: "预约信息", //名称
        },

      ], //子菜单
      icon: "el-icon-s-order", //图标
      namest: "预约审核", //名称
    }

    // 当有权限时,添加多单位查询路由
    let permission = that.$store.state.globalSessionid.data;
    permission.map((i, q) => {
      if (i.RankName == "RankMGroupManage") {
        if (i.Rank == 1) {
          that.allmenu[1].children.push(obj2)
        }
      } else if (i.RankName == "RankMApplyCheck") {
        if (i.Rank == 1) {
          that.allmenu.splice(2, 0, appointment);
        }
      }
    })

  },

  computed: {
    ...mapGetters(["sidebar"]),
    collapse() {

      if (this.sidebar.opened) {
        // this.logoImage = require("../assets/img/logoSmall.png");
      } else {
        this.logoImage = require("../assets/img/logoKu.png");
        // this.logoImage = require("../assets/img/logo10008.png");
      }
      return this.sidebar.opened;
    },
  },
  methods: {
    // 切换菜单列表
    handleSelect(index) {
      // this.$nextTick(() => {
      //   var currentTag = document.getElementsByClassName("name")[6];
      //   var childElement = currentTag ? currentTag.querySelector('li') : null;
      //   childElement.classList.add("customizedCss");
      // });
      // this.changeMenuId(index);
    },
    // 转换路由到id
    changeMenuId(urlst) {
      this.allmenu.map((item) => {
        if (item.children) {
          item.children.map((index) => {
            if ("/" + index.urlst == urlst) {
              // this.$bus.emit("menuId", index.rescid);
              this.$store.commit("getMenuId", index.rescid);
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="less">
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

.el-menu-item-group__title {
  padding: 0px;
}

.el-menu {
  border: none;
}

.logobox {
  height: 70px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 0px;
  width: 100%;
  margin: 10px auto;

  // 给金威单独定制首页 -->
  // span {
  //   color: white;
  //   float: left;
  //   display: inline-block;
  //   margin: 15px 4px;
  // }

  // img {
  //   width: 40%;
  //   float: left;
  // }
}

.el-menu-item.is-active {
  color: #354052;
  background: #f5f5f5 !important;
}

.scrollbar-wrapper {
  margin-right: 0 !important;
  overflow: auto;
}

.customizedCss {
  color: #409EFF;
  font-weight: 900;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue